import { render } from "./SplineChart.vue?vue&type=template&id=1c84cf6d"
import script from "./SplineChart.vue?vue&type=script&lang=js"
export * from "./SplineChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__